import { Component, Input, Output, EventEmitter } from "@angular/core";
import { ApplicationCard } from "../../../../core/models/application-card.model";
import { RnWLPLocalAppVM } from "../../../services/rnapi2-service";

@Component({
    selector: "app-card-list",
    templateUrl: "./card-list.component.html",
    styleUrls: ["./card-list.component.scss"],
    standalone: false
})
export class CardListComponent {
  @Input() cardList: ApplicationCard[] = [];
  @Input() localAppList: RnWLPLocalAppVM[] = [];
  @Input() userID: number;
  @Input() canUseOpenButton = false;
  @Output() cardEvent = new EventEmitter<ApplicationCard>();

  constructor() {}

  handleCardEvent(request: ApplicationCard) {
    this.cardEvent.emit(request);
  }
}
